// extracted by mini-css-extract-plugin
export default {"header":"QuizzAppTemplatePage_header__RiUEq","title":"QuizzAppTemplatePage_title__PJyMb"};